export default __webpack_public_path__ + "static/media/AndJamCol.e818e2d3.jpg";